module.exports = __webpack_public_path__ + "static/media/Fechar.34fb3d12.svg";